import { createSelector } from 'reselect';
import { initialState } from '../reducers/tools/decisionTree/fetchOrder';

// // TODO: check with @Jack  - do we really need fetch order loading... since it loads data from redux
const fetchOrder = (state) => state.tools.decisionTree.fetchOrder || initialState;

const selectLoading = createSelector(fetchOrder, (state) => state.loading);
const selectError = createSelector(fetchOrder, (state) => state.error);

export { selectLoading, selectError };
